module.exports = __webpack_public_path__ + "static/media/Night Rider.45abdbe2.jpg";